import { useEffect, useRef, useState } from "react";
import "./SubForm.css";

export const SubForm = () => {
    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        birthYear: "",
        height: "",
        weight: "",
        sex: "",
        fightType: "",
        weightClass: "",
        beltGrade: "",
        experience: "",
        medicalCertificate: null,
        privacyConsent: false,
        healthData: false,
    });

    const [turnstileToken, setTurnstileToken] = useState("");
    const [captchaError, setCaptchaError] = useState("");
    const turnstileRef = useRef(null);
    const widgetIdRef = useRef(null);

    const currentYear = new Date().getFullYear();

    const age = form.birthYear ? currentYear - Number(form.birthYear) : "";

    const isYouth = age >= 13 && age <= 17;

    const isAdult = age >= 18;

    const showBelt = isYouth || (isAdult && form.fightType === "light");

    const showExperience = isYouth || (isAdult && form.fightType === "light");

    const getFightCategory = () => {
        if (!age) return "";

        if (age >= 13 && age < 15) return "Cadetti A Light";
        if (age === 15) return "Cadetti B Light"
        if (age >= 16 && age <= 17) return "Juniores Light"
        if (age >= 18) {
            if (form.fightType === "light") return "Light";
            if (form.fightType === "semi-pro") return "Semi-Pro";
            if (form.fightType === "pro") return "Pro";
        }
        return "";
    };

    const getWeightClass = (weight, sex) => {
        const w = Number(weight);
        if (!w || !sex) return "";

        if (sex === "maschio") {
            if (w <= 60) return "Peso Gallo";
            if (w <= 67) return "Peso Piuma";
            if (w <= 75) return "Peso Leggero";
            if (w <= 83) return "Peso Welter";
            if (w <= 93) return "Medio-Massimi";
            return "Massimi";
        }

        if (sex === "femmina") {
            if (w <= 52) return "Peso Mosca";
            if (w <= 60) return "Peso Gallo";
            if (w <= 67) return "Peso Piuma";
            return "Peso Leggero";
        }

        return "";
    };


    useEffect(() => {

        const loadTurnstile = () => {
            if (window.turnstile && turnstileRef.current && widgetIdRef.current === null) {
                widgetIdRef.current = window.turnstile.render(turnstileRef.current, {
                    sitekey: process.env.REACT_APP_TURNSTILE_SITE_KEY,
                    theme: "light",
                    callback: (token) => {
                        setTurnstileToken(token);
                        setCaptchaError("");
                    },
                    "expired-callback": () => {
                        setTurnstileToken("");
                        setCaptchaError("Verifica scaduta. Rifalla.");
                    },
                    "error-callback": () => {
                        setTurnstileToken("");
                        setCaptchaError("Errore CAPTCHA. Ricarica la pagina.");
                    },

                });

            }
        };

        if (!document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]')) {
            const script = document.createElement("script");
            script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
            script.async = true;
            script.defer = true;
            script.onload = loadTurnstile;
            document.body.appendChild(script);
        } else {
            loadTurnstile();
        }

        return () => {
            if (window.turnstile && widgetIdRef.current !== null) {
                window.turnstile.remove(widgetIdRef.current);
                widgetIdRef.current = null;
            }
        };
    }, []);

    const handleChange = (e) => {
        const { name, value, files, type, checked } = e.target;
        const newValue = files ? files[0] : type === "checkbox" ? checked : value;

        const updatedForm = {
            ...form,
            [name]: newValue,
        };

        const nextWeight = name === "weight" ? newValue : updatedForm.weight;
        const nextSex = name === "sex" ? newValue : updatedForm.sex;

        updatedForm.weightClass = getWeightClass(nextWeight, nextSex);

        const nextBirthYear = name === "birthYear" ? newValue : updatedForm.birthYear;
        const nextAge = nextBirthYear ? currentYear - Number(nextBirthYear) : "";
        const nextIsYouth = nextAge >= 13 && nextAge <= 17;
        const nextIsAdult = nextAge >= 18;
        const nextFightType = name === "fightType" ? newValue : updatedForm.fightType;
        const beltRequired = nextIsYouth || (nextIsAdult && nextFightType === "light");

        if (nextIsYouth) {
            updatedForm.fightType = "";
        }

        if (nextIsAdult && nextFightType !== "light") {
            updatedForm.experience = "";
        }

        if (!beltRequired) {
            updatedForm.beltGrade = "";
        }

        setForm(updatedForm);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!turnstileToken) {
            setCaptchaError("Completa il controllo anti-bot.");
            return;
        }

        try {
            const data = new FormData();

            data.append("nome", form.firstName);
            data.append("cognome", form.lastName);
            data.append("email", form.email);
            data.append("telefono", form.phoneNumber);
            data.append("eta", new Date().getFullYear() - Number(form.birthYear));
            data.append("sesso", form.sex);
            data.append("peso", Number(form.weight));
            data.append("privacyConsent", String(form.privacyConsent));
            data.append("turnstileToken", turnstileToken);
            data.append("healthData", String(form.healthData));


            if (form.fightType) {
                data.append("fightType", form.fightType);
            }

            if (form.experience !== "") {
                data.append("esperienza", form.experience);
            }

            if (form.beltGrade) {
                data.append("cintura", form.beltGrade);
            }

            if (form.weightClass) {
                data.append("weightClass", form.weightClass);
            }

            if (form.medicalCertificate) {
                data.append("medicalCertificate", form.medicalCertificate);
            }

            const age = new Date().getFullYear() - Number(form.birthYear);

            if (!form.sex) {
                alert("Seleziona il sesso");
                return;
            }

            if (!form.weight) {
                alert("Inserisci il peso");
                return;
            }

            if (age >= 13 && age <= 17) {
                if (!form.beltGrade) {
                    alert("Seleziona la cintura");
                    return;
                }
            }

            if (age >= 18) {
                if (!form.fightType) {
                    alert("Seleziona il tipo gara");
                    return;
                }

                if (form.fightType === "light" && !form.experience) {
                    alert("Inserisci gli anni di esperienza");
                    return;
                }

                if (!form.privacyConsent) {
                    alert("Devi accettare il trattamento dei dati per proseguire");
                    return;
                }

                if (!form.healthData) {
                    alert ("devi accettare il trattamento dei dati sul tuo certificato medico per proseguire");
                    return;
                }
            }

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/register`, {
                method: "POST",
                body: data
            });

            const result = await response.json();

            if (!response.ok) {
                if (result?.error === "Verifica CAPTCHA fallita") {
                    setTurnstileToken("");
                    setCaptchaError("Verifica anti-bot fallita o scaduta. Rifalla.");
                    alert("Verifica anti-bot fallita o scaduta. Rifalla.");
                    return;
                }

                alert(result?.error || "Errore durante l'iscrizione");
                return;
            }

            if (result.success) {
                alert("Iscrizione inviata con successo!");
            } else {
                alert("Errore durante l'iscrizione");
            }

        } catch (err) {
            console.error(err);
            alert("Errore di connessione al server");
        }
    };

    return (
        <div className="subform-container">
            <form className="subform" onSubmit={handleSubmit}>
                <h3 className="subform-title">ISCRIVITI!</h3>

                <input name="firstName" type="text" placeholder="Nome" value={form.firstName} onChange={handleChange} />

                <input name="lastName" type="text" placeholder="Cognome" value={form.lastName} onChange={handleChange} />

                <input name="email" type="email" placeholder="Email" value={form.email} onChange={handleChange} />

                <input name="phoneNumber" type="tel" placeholder="Numero di telefono" value={form.phoneNumber} onChange={handleChange} />

                <input name="birthYear" type="number" placeholder="Anno di nascita" value={form.birthYear} onChange={handleChange} />

                <input name="height" type="number" placeholder="Altezza (cm)" value={form.height} onChange={handleChange} />

                <input name="weight" type="number" placeholder="Peso (kg)" value={form.weight} onChange={handleChange} />

                <select name="sex" value={form.sex} onChange={handleChange}>
                    <option value="">Sesso</option>
                    <option value="maschio">Maschio</option>
                    <option value="femmina">Femmina</option>
                </select>

                {form.weightClass && (
                    <input
                        type="text"
                        className="full-width"
                        value={form.weightClass}
                        readOnly
                        placeholder="Classe di peso"
                    />
                )}

                {form.weight && form.sex && (
                    <input
                        type="text"
                        className="full-width"
                        value={`${form.fightType || getFightCategory()} - ${form.weightClass}`}
                        readOnly
                        placeholder="Categoria assegnata"
                    />
                )}

                {isAdult && (
                    <select name="fightType" value={form.fightType} onChange={handleChange}>
                        <option value="">Tipo gara</option>
                        <option value="light">Light</option>
                        <option value="semi-pro">Semi-Pro</option>
                        <option value="pro">Pro</option>
                    </select>
                )}

                {showBelt && (
                    <select name="beltGrade" value={form.beltGrade} onChange={handleChange}>
                        <option value="">Grado cintura</option>
                        <option value="bianca">Bianca</option>
                        <option value="gialla">Gialla</option>
                        <option value="arancione">Arancione</option>
                        <option value="verde">Verde</option>
                        <option value="blu">Blu</option>
                        <option value="marrone">Marrone</option>
                        <option value="nera">Nera</option>
                    </select>
                )}

                {showExperience && (
                    <input
                        className="full-width"
                        name="experience"
                        type="text"
                        placeholder="Anni di esperienza"
                        value={form.experience}
                        onChange={handleChange}
                    />
                )}

                <label className="file-upload full-width">
                    <span className="file-upload-button">
                        Allega certificato medico
                    </span>
                    <span className="file-upload-name">
                        {form.medicalCertificate
                            ? form.medicalCertificate.name
                            : "Nessun file selezionato"}
                    </span>
                    <input
                        className="full-width"
                        name="medicalCertificate"
                        type="file"
                        accept=".pdf,image/png,image/jpeg"
                        onChange={handleChange}
                    />
                </label>

                <label className="mt-2 flex items-start gap-2 text-sm">
                    <input
                        name="privacyConsent"
                        type="checkbox"
                        checked={form.privacyConsent}
                        onChange={handleChange}
                        className="mt-[2px] h-4 w-4 min-w-4 max-w-4 flex-none rounded bg-transparent accent-red-500"/>
                    <span className="leading-5 text-gray-500 text-justify">
                        Acconsento al trattamento dei dati personali ai fini della gestione
                        dell'iscrizione all'evento, ai sensi della normativa privacy vigente.
                    </span>
                </label>
                <label className="mt-2 flex items-start gap-2 text-sm">                    <input
                        name="healthData"
                        type="checkbox"
                        checked={form.healthData}
                        onChange={handleChange}
                        className="mt-[2px] h-4 w-4 min-w-4 max-w-4 flex-none rounded bg-transparent accent-red-500"/>
                    <span className="leading-5 text-gray-500 text-justify">
                        Dichiaro di aver letto l’informativa privacy e di essere consapevole che il certificato medico
                        caricato può contenere dati relativi alla salute, trattati esclusivamente per la gestione dell’
                        iscrizione e della partecipazione all’evento.
                    </span>
                </label>
                <div className="full-width mt-2 flex flex-col items-center">
                    <div className="flex justify-center w-full">
                        <div ref={turnstileRef}></div>
                    </div>
                    {captchaError && (
                        <p className="mt-2 mb-2 text-sm text-red-400 text-center">{captchaError}</p>
                    )}
                </div>
                <button className="full-width" type="submit">
                    Invia iscrizione
                </button>
            </form>
        </div>
    );
};